import { SDUIComponentInstanceRendererProps } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/__internal__/types";
import { SDUICarouselButton } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/ComponentRenderers/Carousel/__internal__/SDUICarouselButton";
import { SDUITypographyRenderer } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/ComponentRenderers/Typography/SDUITypographyRenderer";
import { IButtonElement } from "@faire/web-api--source/indigofair/data/IButtonElement";
import { ITextElement } from "@faire/web-api--source/indigofair/data/ITextElement";
import { Column, Row } from "@faire/web/slate/Layout";
import { ResponsiveContentV2 } from "@faire/web/ui/ResponsiveContentV2";
import classNames from "classnames";
import React from "react";

import SDUICarouselHeaderTitleMobile from "./SDUICarouselHeaderTitleMobile";

interface IProps
  extends Pick<SDUIComponentInstanceRendererProps, "loggingData"> {
  title?: ITextElement;
  cta_button?: IButtonElement;
  sub_title?: ITextElement;
  tagline?: ITextElement;
  navigationRedesign?: boolean;
}

export const SDUICarouselHeaderRow: React.FC<IProps> = ({
  title,
  cta_button,
  sub_title,
  tagline,
  loggingData,
  navigationRedesign,
}) => {
  if (!title && !sub_title && !tagline && !cta_button) {
    return null;
  }

  const titleUpdated = navigationRedesign
    ? ITextElement.build({
        ...title,
        suffix_c_t_a_on_click: cta_button?.on_click ?? [],
      })
    : title;

  const titleElement = titleUpdated ? (
    <SDUITypographyRenderer
      textElement={titleUpdated}
      loggingData={loggingData}
    />
  ) : null;

  const titleElementResponsive =
    navigationRedesign && cta_button ? (
      <ResponsiveContentV2
        mobile={
          titleUpdated ? (
            <SDUICarouselHeaderTitleMobile
              title={titleUpdated}
              button={cta_button}
              loggingData={loggingData}
            />
          ) : (
            titleElement
          )
        }
        tabletAndAbove={titleElement}
      />
    ) : (
      titleElement
    );

  const ctaButtonElement = cta_button ? (
    <SDUICarouselButton
      button={cta_button}
      loggingData={loggingData}
      navigationRedesign={navigationRedesign}
    />
  ) : null;

  return (
    <Row
      className={classNames(
        "items-center justify-between gap-2 pb-4",
        loggingData?.section_type === "FilterablePaginatedSection"
          ? undefined
          : "px-4 md:px-0"
      )}
    >
      <Column className="gap-1">
        {tagline ? (
          <SDUITypographyRenderer
            textElement={tagline}
            loggingData={loggingData}
          />
        ) : null}
        {titleElementResponsive}
        {sub_title ? (
          <SDUITypographyRenderer
            textElement={sub_title}
            loggingData={loggingData}
          />
        ) : null}
      </Column>
      <ResponsiveContentV2
        mobile={navigationRedesign ? null : ctaButtonElement}
        tabletAndAbove={ctaButtonElement}
      />
    </Row>
  );
};
